import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

/**
 * Tracks the number of currently connected visitors in real-time
 * using Supabase Realtime Presence on a shared channel.
 */
export function useLiveVisitors(channelName = 'site-visitors') {
  const [count, setCount] = useState<number>(1);

  useEffect(() => {
    // Generate a stable visitor id for this tab
    const visitorId =
      sessionStorage.getItem('mdz_visitor_id') ||
      `v_${Math.random().toString(36).slice(2)}_${Date.now()}`;
    sessionStorage.setItem('mdz_visitor_id', visitorId);

    const channel = supabase.channel(channelName, {
      config: { presence: { key: visitorId } },
    });

    channel
      .on('presence', { event: 'sync' }, () => {
        const state = channel.presenceState();
        const total = Object.keys(state).length;
        setCount(total > 0 ? total : 1);
      })
      .subscribe(async (status) => {
        if (status === 'SUBSCRIBED') {
          await channel.track({
            online_at: new Date().toISOString(),
          });
        }
      });

    return () => {
      supabase.removeChannel(channel);
    };
  }, [channelName]);

  return count;
}
